module.exports = __webpack_public_path__ + "static/media/Calendar_1_photo.fadb8f4d.png";